
export { BlurredTextDataType } from "./table.interfaces"